<template>
  <div class="screen-list-page" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="dialogVisible = true"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>新建节目单</el-button
          >
        </div>
      </div>
      <el-table :data="tableData">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="program_name" label="名称"></el-table-column>
        <el-table-column label="屏幕分配">
          <template slot-scope="scope">
            <i
              class="el-icon-upload2 pointer"
              @click="openSend(scope.row)"
              title="屏幕分配"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="添加时间"></el-table-column>
        <el-table-column label="即时投放">
          <template slot-scope="scope">
            <i
              class="el-icon-upload pointer my-icon-button"
              style="font-size:18px"
              @click="nowSend(scope.row.id)"
              title="即时投放"
            ></i>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i
              class="el-icon-edit pointer mar-r10"
              @click="(loading = true), openEdit(scope.row)"
            ></i>
            <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!-- 新增节目单 -->
    <el-dialog
      class="big-dialog"
      title="新增节目单"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <add-program 
        ref="addprogram" 
        @closeMethod="closeAdd"
      ></add-program>
    </el-dialog>

    <el-dialog
      class="big-dialog"
      title="修改节目单"
      :visible.sync="editVisible"
      v-if="editVisible"
    >
      <edit-program
        :editData="editData"
        ref="editprogram"
        @closeMethod="closeEdit"
        @closeLoading="closeLoading"
      ></edit-program>
    </el-dialog>

    <el-dialog
      class="dialog800"
      :title="'节目单分配['+sendData.programName+']'"
      :visible.sync="sendVisible"
      v-if="sendVisible"
    >
      <send-program
        :sendData="sendData"
        ref="sendprogram"
        @closeMethod="closeSend"
      ></send-program>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import addProgram from "@/components/message/program/addProgram.vue"
import editProgram from "@/components/message/program/editProgram.vue"
import sendProgram from "@/components/message/program/sendProgram.vue"
import programApi from "@/api/message/programList"
export default {
  components: { 
    addProgram,
    editProgram,
    sendProgram
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      dialogVisible: false,
      editVisible: false,
      editData: {
        id: null,
        type: 1,
        title: "",
        ste: null,
        uid: null,
        is_double: null,
        stg: []
      },
      sendVisible: false,
      sendData: {
        stg_id: null,
        type: 1,
        stg_name: '',
        is_double: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex
      this.loading = true
      programApi.programList(this.pageInfo).then((res) => {
        // console.log('programList',res)
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openSend(value) {
      let sendParams = { 
        id: value.id, 
        programName: value.programName, 
        deviceCode: value.deviceCode
      }
      this.sendVisible = true
      this.sendData = sendParams
    },
    closeSend() {
      this.sendVisible = false
      this.sendData = {
        id: null,
        programName: '',
        deviceCode: ''
      }
      this.getTableData(this.pageInfo.page);
    },
    closeAdd() {
      this.dialogVisible = false
      this.getTableData(this.pageInfo.page);
    },
    openEdit(program) {
      this.editVisible = true
      this.editData = program
    },
    closeEdit() {
      this.editVisible = false
      this.editData = {
        id: null,
        programName: '',
        time: '',
        fileId: '',
        status: 0
      }
      this.getTableData(this.pageInfo.page);
    },
    closeLoading(){
      this.loading = false
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {          
          programApi.programDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    nowSend(id) {
      programApi.programNowSend({
        id: id,
        areacode: '89f5344da107455c913d22b520abd5fe'
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style lang='less' scoped>
.screen-list-page{
  width: 100%;
}

</style>
